module.exports = __webpack_public_path__ + "hyperion-v2-static/img/download_apple.8108ed87.png";